import { connect } from 'react-redux'
import NewsView from '../../../components/Sections/News'
import { loadNews, setOrder, saveOrder } from '../../../actions/news';

const mapStateToProps = (state, ownProps) => {
  return {
  	news: state.news.list,
  	order: state.news.order
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
  	loadNews: () => dispatch(loadNews()),
  	onChangeOrder: value => {
  		dispatch(setOrder(value.id))
  		dispatch(saveOrder(value))	
  	}
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsView)


// WEBPACK FOOTER //
// ./src/containers/Sections/News/index.js